import logo from '../assets/images/shivaami200.png'
export default function Header({title}) {
    return (
        <>
            <img src={logo} className="img" alt="" />
            <h1> {title} </h1>
        </>

    )
}